<template lang="html">
    <v-dialog persistent scrollable v-model="value" max-width="800">
        <v-card class="disclaimer-modal">
            <v-card-text class="body">
                <img src="/static/bcf.svg" class="mof-logo" alt="Ministry of Forests">
                <h2 class="headline mb-3">Disclaimer</h2>
                <p>
                    The BC Water Tool presents data from a variety of sources related to water resource management. This includes hydrology information derived from hydrological modeling, which contains inherent uncertainty, monitoring data which may contain errors or inaccuracies, and digital representations of water rights which may be inaccurate or incomplete.
                </p>

                <p>
                    The water supply information from hydrology models represents 30-year ‘normal’ or average conditions, and will generally be different from the hydrology measured or observed at any point in time. Model accuracy performance statistics are provided within the reports generated by the BC Water Tool. Users should be aware the predictions for small watersheds (generally smaller than 50 sq. km.) may be less accurate due to the lack of hydrometric data available for small watersheds.
                </p>

                <p>
                    The short term water use and water licence information for existing water rights and use approvals is derived from digital data contained in government databases, and may not represent fully the information contained in individual water use approval or water license documents. In all cases the legal documents should be relied upon where discrepancies exist.
                </p>

                <p>
                    Some of the monitoring data presented here have undergone a formal review and assessment process by the custodian prior to publishing, but others have not. Current year stream discharge values in particular should be considered as provisional.
                </p>

                <p>
                    Wherever possible, the custodian responsible for collecting and managing the data has been identified, and this custodian is the primary contact for any questions regarding the accuracy, QA methods, or any other issue related to data quality.
                </p>

                <p>
                    It is the responsibility of all persons who use this site to independently confirm the accuracy of the data, information, or results obtained through the use of this site, should it be necessary for the user’s purpose. Users requiring access to raw data for their own analysis should acquire such data from the relevant data custodian, to ensure that any revisions or changes made by the custodian are reflected in the data, and that any provisions, caveats, or notes accompanying the raw data can be provided for consideration.
                </p>

                <p>
                    No warranty of quality, accuracy, or completeness of any information, data or product from these web pages is made. No liability or blame for loss or damages incurred by any person or business entity based on the use of the site is accepted. It is provided 'AS IS' without warranty or condition of any nature. No guarantee of any kind is expressed or implied.
                </p>

                <hr class="my-2">

                <p>
                    Proceeding beyond this Disclaimer will constitute your acceptance of the terms and conditions outlined above.
                </p>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click.native="disagree">Disagree</v-btn>
                <v-btn color="primary" @click.native="agree">Agree</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        agree() {
            // dismiss the modal
            this.$emit('input', false);
        },
        disagree() {
            // redirect to a website
            window.location.href = 'https://gov.bc.ca/';
        },
    },
};
</script>

<style lang="scss">
.disclaimer-modal {
    width: 100% !important; // IE11

    .body {
        font-size: 0.9rem;
    }

    .mof-logo {
        height: 8rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/DisclaimerModal.vue